

import React from "react";

const HoverCircles = () => {
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap", // Allow wrapping of items to the next line
    justifyContent: "center",
    alignItems: "center",
    padding: "0 15px",
    gap: "20px",
    margin: "0 auto",
    width: "100%",
  };

  const circleStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "280px", // Set a maximum width for each circle
    height: "280px",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    color: "#000",
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #000",
     boxShadow: "20px 20px 40px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease, color 0.3s ease, border 0.3s ease",
    cursor: "pointer",
    boxSizing: "border-box",
  };

  const hoverStyle = {
    backgroundColor: "#000",
    color: "#FFFFFF",
    border: "2px solid blue",
  };

  const titleContainerStyle = {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "30px",
    fontWeight: "bold",
    color: "#FFA500",
  };

  const circles = [
    {
      title: "Basics of Digital Factory Solutions",
      description:
        "Understand the key digital tools used in modern factories, like automation, IoT (Internet of Things), and data analytics, and how they enhance production.",
    },
    {
      title: "	Practical Applications",
      description:
        "See how Digital Factory Solutions are used in real-world settings to improve manufacturing processes such as assembly lines, quality control, and maintenance.",
    },
    {
      title: "	Improve Productivity and Efficiency",
      description:
        "Learn how digital solutions help increase production speeds, reduce downtime, and improve product quality",
    },
    {
      title: "	Stay Competitive",
      description:
        "Gain insights into how digital technology is revolutionizing the industry and how mastering these tools can make you more valuable in the workforce.",
    },
  ];

  return (
    <div>
      <div style={titleContainerStyle}>
        <span style={{ color: "#000", fontFamily: "roboto" }}>WHY YOU SHOULD</span>{" "}
        <span style={{ color: "#FFA500", fontFamily: "roboto" }}>ATTEND</span>
      </div>

      <div style={containerStyle}>
        {circles.map((circle, index) => (
          <div
            key={index}
            style={circleStyle}
            onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = circleStyle.backgroundColor;
              e.currentTarget.style.color = "#000";
              e.currentTarget.style.border = circleStyle.border;
            }}
          >
            <h3
              style={{
                margin: "10px 0",
                fontSize: "20px",
                color: "orange",
                fontFamily: "roboto",
              }}
            >
              {circle.title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                padding: "10px",
                margin: "0",
                textAlign: "center",
              }}
              dangerouslySetInnerHTML={{ __html: circle.description }}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        @media (max-width: 1200px) {
          h3 {
            font-size: 18px;
          }

          p {
            font-size: 12px;
          }
        }

        @media (max-width: 768px) {
          .container {
            flex-direction: column;
          }

          .circle {
            max-width: 90%; // Adjust the width for mobile
            height: 240px;
          }

          .title {
            font-size: 24px;
          }
        }

        @media (max-width: 480px) {
          h3 {
            font-size: 16px;
          }

          p {
            font-size: 12px;
          }

          .circle {
            height: 220px;
          }
        }
      `}</style>
    </div>
  );
};

export default HoverCircles;



